import { args } from '../../common/args';
import { defineCapability } from '../internal';

export const GLOBAL_HOME_WIDGET_TRACKING_CAP = defineCapability({
  name: 'GLOBAL_HOME_WIDGET_TRACKING_CAP' as const,
  args: {
    trackingId: args.string(),
    trackingStage: args.or(
      args.literal('started'),
      args.literal('success'),
      args.literal('failure'),
      args.literal('noData')
    ),
  },
});
